export default __webpack_public_path__ + "static/media/ic-close-big.03e34ffd.svg";